import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RIValidationIndicacionContent } from '../RIValidationIndicacion/components/RIValidationIndicacionContent';

export default function RICambioIndicacion() {
    return (
        <>
            <MainContent
                component={<RIValidationIndicacionContent esCambioIndicacion />}
                titulo='Cambio de indicación'
                noBackground
                tableMaxWidth
            />
        </>
    );

};